var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.goTopShow)?_c('div',{staticClass:"back-top",on:{"click":_vm.goTop}},[_c('span',{staticClass:"iconfont icon-to-top-line"}),_c('span',{staticClass:"txt_tip"},[_vm._v("返回顶部")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }